import { xml2js } from "xml-js";
import { XmlOptions } from "../XmlEditor/XmlEditor";
import { dpAssert, isAdminPage } from "../../sharedTypes/helpers";
import { ManagerEntity } from "@/shared/globalFunctions";

export class Mapper {
    public xmlObject: any;
    public notes: Element[] = []
    refreshXmlObject(musicxml: string) {
        if (isAdminPage()) {
            this.xmlObject = xml2js(musicxml, XmlOptions);
        }
    }
}
export function getNoteFromXmlByNoteId(xmlRoot: any, noteId: string): any {
    dpAssert(ManagerEntity.core);
    const note = ManagerEntity.core.noteHashMap[noteId]
    const measure = ManagerEntity.core.timemap[note.measureIndex]
    const noteInMeasureIndex = note.midi.indexInXmlParent;
    const measureIndex = measure.indexInXmlParent;
    if (noteInMeasureIndex === 0 || noteInMeasureIndex) {
        return getNoteFromXml(xmlRoot, measureIndex, noteInMeasureIndex)
    }
}
// function that will get for us noteFromTimemapIndex and measureIndex
export function getNoteFromXml(xmlRoot: any, measureIndexInXmlParent: number, noteIndexInXmlparent: number) {
    // find that note in xml
    const xmlPart = xmlRoot.elements[1].elements.find(
        (e: any) => e.name === 'part',
    );
    const xmlMeasures = xmlPart.elements.filter((e: any) => e.name === 'measure');
    const xmlMeasure = xmlMeasures[measureIndexInXmlParent];
    const xmlNotes = xmlMeasure.elements.filter((e: any) => e.name === 'note');
    const note = xmlNotes[noteIndexInXmlparent];
    return note;
}
export function getMeasureFromXml(xmlRoot: any, measureIndexInXmlParent: number) {
    const xmlPart = xmlRoot.elements[1].elements.find(
        (e: any) => e.name === 'part',
    );
    const xmlMeasures = xmlPart.elements.filter((e: any) => e.name === 'measure');
    const xmlMeasure = xmlMeasures[measureIndexInXmlParent];
    return xmlMeasure
}
const MapperEntity = new Mapper();

export default MapperEntity